module.exports = __webpack_public_path__ + "img/insurance.ee42c62f.png";